<template>
  <router-link v-if="!disabled" :to="routeTo" class="link" tabindex="0">
    <slot></slot>
  </router-link>
  <a v-else class="link__disabled">
    <slot></slot>
  </a>
</template>

<script>
export default {
  name: "AppLink",
  props: {
    routeTo: { type: [String, Object], required: true },
    disabled: { type: Boolean, default: false }
  }
};
</script>

<style scoped lang="scss">
.link {
  display: inline-block;
  outline: none;
  color: $group-2-color-3;

  &:hover {
    text-decoration: underline;
  }

  &-color {
    color: $group-2-color-3;
  }

  &__disabled {
    cursor: default;
    opacity: 0.4;
    &:hover {
      text-decoration: none;
    }
  }
}
</style>
